<template>
  <div id="Podzespoly">
    <md-dialog :md-active.sync="showDialog" :md-click-outside-to-close="false" :md-close-on-esc="false">
      <md-dialog-actions>
        <em style="width: 100%;
  padding: 0px 8px;
  color: green;
  font-weight: 400;">{{msg}}</em>
        <md-button class="md-primary" @click="clickClose(false)">{{$t('message.zamknij')}}</md-button>
      </md-dialog-actions>
      <md-dialog-title>{{$t('message.akces_ARAD')}}</md-dialog-title>
        <div style="width: 730px;margin-bottom: 12px;">
          <table style="margin: 0px auto; width: 635px;" v-if="ListaPodzespoly && Object.keys(ListaPodzespoly).length>0">
            <tr style="background: rgb(120, 120, 120);color: white;font-weight: normal;">
              <th>{{$t('message.ilosc')}}</th><th>{{$t('message.kod')}}</th><th>{{$t('message.nazwa')}}</th><th v-if="$i18n.locale === 'pl'">{{$t('message.cena')}}</th>
            </tr>
            <template v-for="(item) in ListaPodzespoly">
              <template v-if="item.symbol.indexOf('ARAS') > -1 && item.symbol !== 'ARAS' + Number(outputs.szafa.glebokosc) && item.symbol !== 'ARAS' + Number(outputs.szafa.glebokosc)+'N'">

              </template>
              <template v-else >
                <tr :key="item.symbol">
                  <td>
                  <!-- {{nr}}
                  {{outputs.podzespoly[nr]}} -->
                  <!-- <input v-on:input="modifyPodzespoly(item)" type="number" style="width:50px" min=0 placeholder="0"> -->
                  <input v-on:input="modifyPodzespoly(countInputs[item.symbol], item)" type="number" style="width:50px" v-model="countInputs[item.symbol]" min=0 placeholder="0">
                  </td>
                  <td><b>{{item.symbol}}</b></td>
                  <td>{{item.nazwa}}</td>
                  <td v-if="$i18n.locale === 'pl'">{{Number(item.cena).toFixed(2)}}</td>
                </tr>
              </template>
            </template>
          </table>
        </div>
        <!-- {{showDialog}} {{symbol}} {{nr}} -->
    </md-dialog>

  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { app } from '../../mixins/app'

export default {
  name: 'DialogPodzespoly',
  mixins: [app],
  props: ['showDialog', 'symbol', 'nr'],
  data () {
    return {
      countInputs: {},
      msg: ''
    }
  },
  computed: {
    ...mapGetters('app', ['outputs']),
    ...mapGetters('products', ['ListaPodzespoly'])
  },
  watch: {
    showDialog (newValue) {
      if (newValue) {
        this.countInputs = {}
        this.$store.dispatch('products/load_list_podzespoly', [this.symbol, this.$i18n.locale])
        this.showTable = true
        if (this.outputs.podzespoly[this.nr]) {
          // console.log('jest')
          Object.keys(this.outputs.podzespoly[this.nr]).forEach(element => {
            // console.log(element)
            this.countInputs[element] = this.outputs.podzespoly[this.nr][element].value
          })
        } else {
          // console.log('brak')
        }
      }
    }
  },
  methods: {
    clickClose (val) {
      this.$store.commit('products/CLEAR_LIST_PODZESPOLY')
      this.$emit('clickClose', val)
    },
    modifyPodzespoly (value, item) {
      // console.log(this.nr)
      item.value = value
      // if (this.outputs.podzespoly[this.nr]) {
      //   console.log(this.outputs.podzespoly[this.nr])
      // }
      // console.log(this.nr, item)
      this.$store.commit('app/UPDATED_OUTPUTS_PODZESPOLY', [this.nr, item])
      this.changeText()
    },
    changeText () {
      this.msg = this.$i18n.messages[this.$i18n.locale]['message']['autosave']
      setTimeout(() => {
        this.msg = ''
      }, 1000)
    }
  }
}
</script>

<style scoped>
tr:nth-child(even) {background-color: #f2f2f2;}
tr:nth-child(odd) {background-color: #fdfdfd}
table tr td {
padding: 0px 5px;
}
table tr th {
padding: 4px;
}
.md-dialog-title {
  margin-bottom: 10px;
  padding: 0px 30px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Dialogs/Podzespoly.vue